import React, { Component } from 'react';
import TitleBar from '../components/TitleBar';
import { Link } from 'react-router-dom';
import { keyBy as _keyBy } from 'lodash';

import Constants from '../lib/Constants';
import * as ClientApi from '../api/ClientApi';
import * as UserApi from '../api/UserApi';

import ClientModalForm from '../components/ClientForms/ClientModalForm';

class ClientList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            clients: null,
            usersById: null,
            filteredClients: null,
            showingClientForm: false,
            editingClient: null,
        };
    }

    componentDidMount() {
        ClientApi.list()
            .then(data => {
                this.setState({ clients: data.clients, filteredClients: data.clients });
            })
            .catch(error => {
                
            });

        UserApi.list()
            .then(data => {
                this.setState({ usersById: _keyBy(data.users, 'id') });
            })
            .catch(error => {

            });
        this.setPageTitle();
    }

    setPageTitle() {
        document.title = Constants.pageTitleBase;
    }

    showClientForm = (client) => {
        this.setState({ showingClientForm: true, editingClient: client ? client : null });
    }

    hideClientForm = () => {
        this.setState({ showingClientForm: false, editingClient: null });
    }

    handleSearchInputChange = (event) => {
        if (!event.target.value) {
            this.setState({ filteredClients: this.state.clients });
        }
        const term = `${event.target.value}`.toLowerCase().trim();
        this.setState({
            filteredClients: (this.state.clients || []).filter(c => c.name.toLowerCase().includes(term)),
        });
    }

    render() {
        let clientList;
        if(this.state.filteredClients) {
            clientList = this.state.filteredClients.map((client, index) =>
                <tr key={client.client_id}>
                    <td>
                        <Link
                            className="nav-link"
                            to={ "/clients/" + client.client_id }>
                            {client.name}
                        </Link>
                    </td>
                    <td className="text-right">
                        {client.fy_end_month} - {client.fy_end_day}
                    </td>
                    <td className="text-right">
                        {client.last_pu_fy}
                    </td>
                    <td className="text-center">
                        { client.analyst_user_id ? this.state.usersById?.[client.analyst_user_id]?.last_name : '' }
                    </td>
                    <td className="text-center">
                        <a onClick={() => {this.showClientForm(client);}}>
                            <i className="icon icon-edit" />
                        </a>
                    </td>
                </tr>
            );
        }

        return (
            <div>
                <TitleBar pageTitle="Clients" />
                
                <div className="clear-title-bar">
                    <div style={{ maxWidth: '500px'}} className="pt-3 pl-3">
                        <div className="p-2 d-flex w-100 entity-search-item justify-content-between">
                            <input
                                className="form-control rounded-0"
                                type="text"
                                placeholder="Search Clients" 
                                onChange={ this.handleSearchInputChange } />
                            
                            <a className="btn btn-outline" onClick={() => { this.showClientForm(); }}>
                                <i className="icon icon-plus" /> Add Client
                            </a>
                        </div>
                        <table className="table table-data table-hover table-condensed">
                            <thead>
                                <tr className="bottom-dotted-border">
                                    <th style={{width: '38%'}} className="pl-3">Client</th>
                                    <th style={{width: '20%'}} className="text-right">FY End</th>
                                    <th style={{width: '20%'}} className="text-right">Last PBU FY</th>
                                    <th style={{width: '20%'}} className="text-center">Analyst</th>
                                    <th style={{width: '2%'}}>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                { clientList }
                            </tbody>
                        </table>
                    </div>
                </div>
                <ClientModalForm
                    client={this.state.editingClient}
                    show={this.state.showingClientForm}
                    onHide={this.hideClientForm} />
            </div>
        );
    }
}

export default ClientList;
